import {Injectable} from "@angular/core";
import {HttpErrorResponse} from "@angular/common/http";
import {BehaviorSubject} from "rxjs";
import {AuthenticationService} from "./authentication.service";
import {NzMessageService} from "ng-zorro-antd/message";


@Injectable({
  providedIn: 'root'
})
export class ResponseHandlerService {

  private errorMsg$ = new BehaviorSubject('')

  constructor(
    private authService: AuthenticationService,
    private nzMessageService: NzMessageService
  ) {}

  get errorMsg() {
    return this.errorMsg$.asObservable();
  }

  handleHttpResponseError(e: HttpErrorResponse) {
    const bussinessMsg = e.error.msg ?? 'Ocorreu um erro inesperado. Tente novamente mais tarde.';
    this.nzMessageService.error(bussinessMsg);
    this.errorMsg$.next(bussinessMsg)
    if (e.status === 401) {
      this.authService.logout()
    }
  }

}
